<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $t('messages.stats'),
                        href: null,
                    },
                ]"
            />
        </template>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-12">
                    <FormLabel :value="$t('messages.grade_level')" for="grade_level_ids" />
                    <div class="mt-1">
                        <label v-for="grade_level in gamificationSet.grade_levels" class="mr-1" :key="grade_level.id">
                            {{ grade_level.name }}
                        </label>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <NavLinks :links="groups" />

        <div class="flex justify-end">
            <FormSelect
                required
                v-model="form.action_name"
                :options="options.action_names"
                class="mt-1"
                :null-option="false"
            />
        </div>
        <div>
            <GraphSortable
                :data-orders="activityLogsActionChart.dataOrders"
                :input-options="activityLogsActionChart.chart"
                :non-alphabetical-order="activityLogsActionChart.otherOrderText"
            />
        </div>
        <div class="flex space-x-2">
            <BadgePill
                v-for="(textAnnotation, index) in activityLogsActionChart.textAnnotations"
                :color="textAnnotation.color"
                :key="index"
            >
                {{ textAnnotation.text }}: ({{ textAnnotation.value }} {{ $tc('messages.points', 2) }})
            </BadgePill>
        </div>

        <div>
            <GraphSortable
                :data-orders="activityLogsDashboardChart.dataOrders"
                :input-options="activityLogsDashboardChart.chart"
                :non-alphabetical-order="activityLogsDashboardChart.otherOrderText"
            />
        </div>
        <div class="flex space-x-2">
            <BadgePill
                v-for="(textAnnotation, index) in activityLogsDashboardChart.textAnnotations"
                :color="textAnnotation.color"
                :key="index"
            >
                {{ textAnnotation.text }}: ({{ textAnnotation.value }} {{ $tc('messages.points', 2) }})
            </BadgePill>
        </div>

        <div>
            <GraphSortable
                :data-orders="maxExperienceChart.dataOrders"
                :input-options="maxExperienceChart.chart"
                :non-alphabetical-order="$tc('messages.experience_points', 2)"
            />
        </div>
        <div class="flex space-x-2">
            <BadgePill
                v-for="(textAnnotation, index) in maxExperienceChart.textAnnotations"
                :color="textAnnotation.color"
                :key="index"
            >
                {{ textAnnotation.text }}: ({{ textAnnotation.value }} {{ $tc('messages.points', 2) }})
            </BadgePill>
        </div>

        <div>
            <GraphSortable
                :data-orders="totalCoinsChart.dataOrders"
                :input-options="totalCoinsChart.chart"
                :non-alphabetical-order="$t('messages.coins_amount')"
            />
        </div>
        <div class="flex space-x-2">
            <BadgePill
                v-for="(textAnnotation, index) in totalCoinsChart.textAnnotations"
                :color="textAnnotation.color"
                :key="index"
            >
                {{ textAnnotation.text }}: ({{ textAnnotation.value }} {{ $tc('messages.points', 2) }})
            </BadgePill>
        </div>
    </PanelPage>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';

import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import GraphSortable from '@/components/pageSpecific/GraphSortable.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        PanelPage,
        TitleFieldsFormSection,
        FormSelect,
        FormLabel,
        BadgePill,
        GraphSortable,
    },
    props: [
        'meta',
        'filters',
        'gamificationSet',
        'maxExperienceChart',
        'totalCoinsChart',
        'activityLogsDashboardChart',
        'activityLogsActionChart',
        'groups',
        'options',
    ],
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                action_name: this.filters.action_name,
            }),
        };
    },
    name: 'Show',
    computed: {},
    methods: {
        filter() {
            this.form.get(this.meta.links.show, {
                preserveScroll: true,
                only: ['activityLogsActionChart', 'filters'],
            });
        },
    },
    watch: {
        'form.action_name': {
            handler() {
                this.filter();
            },
            deep: true,
        },
    },
};
</script>
